<template>
  <div class="container">
    <h1>🏆 Generador de URL para Eventos Bernabéu</h1>

    <TextInput v-model="evento" label="📌 Nombre del evento" placeholder="Ej. Lanzamiento Q3" />
    <TextInput v-model="empresa" label="🏢 Empresa / Organización" placeholder="Ej. ACME S.A." />
    <DateInput v-model="fecha" label="📅 Fecha del evento" />
    <SelectRol v-model="rol" label="👤 Rol del participante" />
    <SelectEspacio v-model="espacio" label="🏟️ Espacio o sala contratada" />

    <ResultUrl :url="urlGenerada" />
  </div>
</template>

<script>
import TextInput from './components/TextInputField.vue'
import DateInput from './components/DateInput.vue'
import SelectRol from './components/SelectRol.vue'
import SelectEspacio from './components/SelectSpace.vue'
import ResultUrl from './components/ResultUrl.vue'

export default {
  components: {
    TextInput,
    DateInput,
    SelectRol,
    SelectEspacio,
    ResultUrl
  },
  data() {  
    return {
      baseUrl: "https://encuesta.com/survey/gQAeLI40d7/",
      evento: '',
      empresa: '',
      fecha: '',
      rol: '',
      espacio: ''
    }
  },
  computed: {
    urlGenerada() {
      if (!this.evento || !this.empresa || !this.fecha || !this.rol || !this.espacio) return ''

      const params = new URLSearchParams({
        evento: this.evento,
        fecha: this.formatearFecha(this.fecha),
        empresa: this.empresa,
        rol: this.rol, // si es 'otro', se pasa el texto
        espacio: this.espacio
      })

      return `${this.baseUrl}?${params.toString()}`
    }
  },
  methods: {
    formatearFecha(fechaISO) {
      const [year, month, day] = fechaISO.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style>
.container {
  max-width: 600px;
  margin: auto;
  margin-top: 3.5rem;
  padding: 2rem;
  font-family: "Segoe UI", sans-serif;
  background-color: rgba(245, 245, 245); 
  border-radius: 12px; 
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); 
}


body::before {
  content: "";
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: -1;
  background: url('./assets/background_image.jpg') no-repeat center center fixed;
  background-size: cover;
  opacity: 0.2; 
  pointer-events: none;
}


.input-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  gap: 0.5rem;
  
}

label {
  margin-bottom: 6px;
  font-weight: 600;
}

input,
select {
  padding: 10px;
  font-size: 15px;
  border-radius: 6px;
  border: 1px solid #ccc;
  transition: 0.3s ease;
}

input:focus,
select:focus {
  border-color: #007bff;
  outline: none;
}

h1 {
  margin-bottom: 2rem;
  font-size: 24px;
  text-align: center;
}

.result-container {
  margin-top: 2rem;
}

.url-box {
  display: flex;
  gap: 0.5rem;
}

.url-box input {
  flex: 1;
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

}

.url-box button {
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}

.gradient-button {
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  background: linear-gradient(90deg, #a72fff, #b45ef1);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out, color 0.2s ease-in-out;
}

.gradient-button:hover {
  transform: scale(1.03);
}
</style>

